import SearchIcon from "@mui/icons-material/Search";
import ControlFilter from "components/shared/ControlFilter";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";

import type { SearchMode } from "./useCommandPaletteState";

type Props = {
    mode: SearchMode;
    setMode: (mode: SearchMode) => void;
    modeOptions: { value: SearchMode; label: string }[];
    isCrealoAdmin: boolean;
    hasMultipleCompanies: boolean;
    isPressLike: boolean;
    portalType: string;
    query: string;
    setQuery: (value: string) => void;
    t: (key: string) => string;
};

export const CommandPaletteHeader = ({
    mode,
    setMode,
    modeOptions,
    isCrealoAdmin,
    hasMultipleCompanies,
    isPressLike,
    portalType,
    query,
    setQuery,
    t,
}: Props) => {
    const searchDataPlaceholder = isPressLike
        ? t(`CommandPalette.SearchData_${portalType}`)
        : t("CommandPalette.SearchData");
    return (
        <div className="command-palette__header">
            {(isCrealoAdmin || hasMultipleCompanies) && (
                <div className="command-palette__header-switch">
                    <ControlFilter
                        filterOptions={modeOptions}
                        controlValue={mode}
                        onValueChange={(value: SearchMode) => setMode(value)}
                        selector={false}
                    />
                </div>
            )}
            <div className="command-palette__search-wrapper">
                <StyledTextField
                    autoFocus
                    fullWidth
                    size="small"
                    placeholder={mode === "company" ? t("CommandPalette.SearchCompany") : searchDataPlaceholder}
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    className="command-palette__search"
                    icon={<SearchIcon sx={{ fontSize: 18, color: "#9CA3AF" }} />}
                />
            </div>
        </div>
    );
};
